import React from 'react';
import { Tooltip } from '@nextui-org/react';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import { SiCodechef, SiGmail } from 'react-icons/si';
import { IoLogoOctocat } from 'react-icons/io';
import { TbBrandLeetcode } from 'react-icons/tb';

import Reveal from './Reveal';
import { SOCIALS } from '../data/site';

const LINKS = [
  { key: 'leetcode', label: 'LeetCode', href: SOCIALS.leetcode, icon: <TbBrandLeetcode /> },
  { key: 'codechef', label: 'CodeChef', href: SOCIALS.codechef, icon: <SiCodechef /> },
  { key: 'codolio', label: 'Codolio', href: SOCIALS.codolio, icon: <IoLogoOctocat /> },
  { key: 'github', label: 'GitHub', href: SOCIALS.github, icon: <AiFillGithub /> },
  { key: 'linkedin', label: 'LinkedIn', href: SOCIALS.linkedin, icon: <AiFillLinkedin /> },
  { key: 'email', label: 'Email', href: `mailto:${SOCIALS.email}`, icon: <SiGmail /> },
];

const NAV = [
  { href: '#skills', label: 'Skills' },
  { href: '#education', label: 'Education' },
  { href: '#experience', label: 'Experience' },
  { href: '#project', label: 'Projects' },
];

export default function NewFooter() {
  return (
    <footer className="footer-x" id="contact">
      <div className="footer-inner">
        <Reveal>
          <h2 className="footer-cta">
            Let&apos;s build something <span className="grad">amazing</span>
          </h2>

          <p className="footer-sub">
            I&apos;m open to SDE roles and interesting collaborations. The fastest way
            to reach me is email &mdash; I reply to everything.
          </p>

          <a href={`mailto:${SOCIALS.email}`} className="btn-primary-x">
            {SOCIALS.email}
          </a>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="footer-socials" style={{ marginTop: 40 }}>
            {LINKS.map((l) => (
              <Tooltip
                key={l.key}
                content={l.label}
                closeDelay={0}
                classNames={{ content: 'tooltip-x' }}
              >
                <a
                  href={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={l.label}
                >
                  {l.icon}
                </a>
              </Tooltip>
            ))}
          </div>
        </Reveal>

        <nav className="footer-nav">
          {NAV.map((n) => (
            <a key={n.href} href={n.href}>
              {n.label}
            </a>
          ))}
        </nav>

        <div className="footer-bottom">
          <div>&copy; {new Date().getFullYear()} Harshit Pandey &middot; Built with React</div>
        </div>
      </div>
    </footer>
  );
}
